import _implicitStylesheets from "./fileTree.css";
import _implicitScopedStylesheets from "./fileTree.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="chevron-spacer${0}"${2}></span>`;
const $fragment2 = parseFragment`<span class="name${0}"${2}>${"t1"}</span>`;
const $fragment3 = parseFragment`<span class="name${0}"${2}>${"t1"}</span>`;
const stc0 = {
  "file-tree": true
};
const stc1 = {
  "row": true
};
const stc2 = {
  classMap: {
    "file": true
  },
  key: 2
};
const stc3 = {
  classMap: {
    "dir": true
  },
  key: 8
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, ti: api_tab_index, k: api_key, st: api_static_fragment, c: api_custom_element, d: api_dynamic_text, sp: api_static_part, h: api_element, i: api_iterator} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [api_element("ul", {
    classMap: stc0,
    attrs: {
      "role": "tree",
      "aria-label": $cmp.treeLabel
    },
    key: 0,
    on: {
      "keydown": _m0 || ($ctx._m0 = api_bind($cmp.handleTreeKeyDown))
    }
  }, api_iterator($cmp.rows, function (row) {
    return api_element("li", {
      classMap: stc1,
      style: row.indentStyle,
      attrs: {
        "data-has-border": row.hasLeftBorder,
        "data-depth": row.depth,
        "data-path": row.path,
        "data-selected": row.isSelected,
        "role": "treeitem",
        "aria-label": row.ariaLabel,
        "aria-level": row.ariaLevel,
        "aria-expanded": row.ariaExpanded,
        "aria-selected": row.ariaSelected,
        "aria-current": row.ariaCurrent,
        "tabindex": api_tab_index(row.tabIndex)
      },
      key: api_key(1, row.path),
      on: {
        "click": _m1 || ($ctx._m1 = api_bind($cmp.handleRowClick)),
        "focus": _m2 || ($ctx._m2 = api_bind($cmp.handleRowFocus))
      }
    }, [row.isFile ? api_element("div", stc2, [api_static_fragment($fragment1, 4), api_custom_element("ax-icon", _axIcon, {
      props: {
        "icon": row.icon,
        "size": "xsmall",
        "ariaHidden": "true"
      },
      key: 5
    }), api_static_fragment($fragment2, 7, [api_static_part(1, null, api_dynamic_text(row.name))])]) : null, !row.isFile ? api_element("div", stc3, [api_custom_element("ax-icon", _axIcon, {
      props: {
        "icon": row.chevronIcon,
        "size": "xsmall",
        "ariaHidden": "true"
      },
      key: 9
    }), api_custom_element("ax-icon", _axIcon, {
      props: {
        "icon": row.icon,
        "size": "xsmall",
        "ariaHidden": "true"
      },
      key: 10
    }), api_static_fragment($fragment3, 12, [api_static_part(1, null, api_dynamic_text(row.name))])]) : null]);
  }))];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2u9skg78ap4";
tmpl.legacyStylesheetToken = "undefined-_fileTree";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
